import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VMEInteractiveScheduleComponent } from './vme-interactive-schedule.component';
import { VmeCommonModule } from '../../../vme-common.module';
import { VmeDirectivesModule } from '../../../vme-directives.module';
import { VmePipesModule } from '../../../vme-pipes.module';
import { VMEComponentsModule } from '../../../vme-components.module';
import { InteractiveScheduleModule } from '../interactive-schedule.module';

const routes: Routes = [
  { path: '', component: VMEInteractiveScheduleComponent, data: { title: 'Interactive Schedule' } },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class VMEInteractiveScheduleRoutingModule {}

@NgModule({
  imports: [
    VMEInteractiveScheduleRoutingModule,
    InteractiveScheduleModule,
    VmeCommonModule,
    VmeDirectivesModule,
    VmePipesModule,
    VMEComponentsModule,
  ],
  declarations: [VMEInteractiveScheduleComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  exports: [VMEInteractiveScheduleComponent],
})
export class VMEInteractiveScheduleModule {}
